import { Currency, ETHER, Token } from '@uniswap/sdk'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import { getCurrencyDisplaySymbol, getWrappedNativeCurrency } from '../../constants/chains'
import useHttpLocations from '../../hooks/useHttpLocations'
import { WrappedTokenInfo } from '../../state/lists/hooks'
import Logo from '../Logo'

const getTokenLogoURL = (address: string) =>
  `https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/${address}/logo.png`

const StyledNativeLogo = styled.img<{ size: string }>`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.075);
  border-radius: 24px;
`

const StyledLogo = styled(Logo)<{ size: string }>`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
`

export default function CurrencyLogo({
  currency,
  size = '24px',
  style
}: {
  currency?: Currency
  size?: string
  style?: React.CSSProperties
}) {
  const uriLocations = useHttpLocations(currency instanceof WrappedTokenInfo ? currency.logoURI : undefined)

  const srcs: string[] = useMemo(() => {
    if (currency === ETHER) return []

    if (currency instanceof Token) {
      if (currency instanceof WrappedTokenInfo) {
        return [...uriLocations, getTokenLogoURL(currency.address)]
      }

      return [getTokenLogoURL(currency.address)]
    }
    return []
  }, [currency, uriLocations])

  const wrappedNative = currency instanceof Token ? getWrappedNativeCurrency(currency.chainId) : undefined
  if (currency === ETHER || (currency instanceof Token && wrappedNative?.equals(currency))) {
    return (
      <StyledNativeLogo
        src="/images/interstellar-token-logo.png"
        size={size}
        alt={`${getCurrencyDisplaySymbol(currency) ?? 'native currency'} logo`}
        style={style}
      />
    )
  }

  return <StyledLogo size={size} srcs={srcs} alt={`${getCurrencyDisplaySymbol(currency) ?? 'token'} logo`} style={style} />
}
